import { string, bool } from 'prop-types';

export const healthCheckType = {
  healthy: bool,
  message: string
};
